import React, { useState, ReactElement } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import StyledButton from "components/buttons/StyledButton";
import StyledTextField from "components/inputs/StyledTextField";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import StyledCheckBox from "components/inputs/StyledCheckBox";
import EmailSubscriptionListType from "models/EmailSubscriptionListType";
import { backendApi } from "apiConsumers";

// @ts-ignore
import { serialize } from "react-serialize";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        textField: {
            flex: "1 1 auto",
        },
        snackBar: {
            border: `2px solid ${theme.palette.common.black}`,
            backgroundColor: theme.palette.common.white,
            color: theme.palette.common.black,
            padding: theme.spacing(2),
        },
    });
});

interface IProps {
    list: EmailSubscriptionListType;
    termsLabel?: ReactElement;
}

export default function useSubscriptionForm(props: IProps) {
    const classes = useStyles();
    const { list, termsLabel } = props;

    const defaultAgreed = false;
    const defaultEmail = "";

    const [agreed, setAgreed] = useState(defaultAgreed);
    const [email, setEmail] = useState(defaultEmail);
    const [errorMessage, setErrorMessage] = useState("");
    const [modalMessage, setModalMessage] = useState("");

    const onCheckboxClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAgreed(event.target.checked);
    };

    const validateEmail = (_email: string) => {
        return _email.includes("@");
    };

    const onsubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        postData();
    };
    const onSignUp = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        postData();
    };

    const postData = () => {
        const validEmail = validateEmail(email);
        if (!validEmail) {
            setErrorMessage("Please enter a valid email");
            return;
        }

        if (typeof termsLabel !== "undefined" && !agreed) {
            setErrorMessage("You must agree to the terms");
            return;
        }

        setAgreed(defaultAgreed);
        setEmail(defaultEmail);
        setErrorMessage("");

        let termsLabelText: string | undefined;
        if (typeof termsLabel !== "undefined") {
            termsLabelText = serialize(termsLabel.props.children);
        }

        backendApi
            .subscribeEmail(email, list, termsLabelText)
            .then(() => {
                setModalMessage("Succesfully registered " + email);
            })
            .catch((err) => {
                setModalMessage("We couldn't process your request, please try again");
            });
    };

    const handleEmailChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const email = event.target.value.toLowerCase();

        setEmail(email);
    };

    const onSnackbarClose = () => {
        setModalMessage("");
    };

    return {
        inputComponent: (
            <>
                <Snackbar
                    open={modalMessage.length > 0}
                    autoHideDuration={6000}
                    onClose={onSnackbarClose}
                    className={classes.snackBar}
                >
                    <Typography variant="body1">{modalMessage}</Typography>
                </Snackbar>

                <form noValidate onSubmit={onsubmit} style={{ flex: "1", display: "flex" }}>
                    <StyledTextField
                        error={errorMessage.length > 0}
                        helperText={errorMessage.length > 0 ? errorMessage : " "}
                        className={classes.textField}
                        value={email}
                        id="email-text-field"
                        placeholder="email address"
                        onChange={handleEmailChange}
                        margin="dense"
                    />
                </form>
            </>
        ),
        termsLabel:
            typeof termsLabel === "undefined" ? undefined : (
                <FormGroup>
                    <FormControlLabel
                        control={
                            <StyledCheckBox
                                checked={agreed}
                                onChange={onCheckboxClick}
                                name="checkedA"
                            />
                        }
                        label={termsLabel}
                    />
                </FormGroup>
            ),
        signUpButton: <StyledButton onClick={onSignUp}>Sign Up</StyledButton>,
    };
}
